export function generateIframeFromUrl(url, width = "100%", height = "315") {
  // Define the regular expression pattern to extract latitude and longitude
  // Search for the pattern in the URL

  return `<iframe src="${url}" width=${width} height=${height} style="border:0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;
  
}
